import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  signal,
  untracked
} from '@angular/core';
import { PageComponent } from '../../layout/page/page.component';
import { TranslationService } from '../../../core/services/translation/translation.service';
import { formLanguageReloader } from '../../../core/helpers/page.helper';
import { ActivatedRoute } from '@angular/router';
import { LogService } from '../../../core/services/log/log.service';
import { UserService } from '../../user-connection/user.service';
import { ApplicationStore } from '../../../core/services/application-store.service';
import { LoaderComponent, NoValue } from '@tribeauto/ngx-mobilite-material';
import { AppConfig } from '../../../app.config';

@Component({
  selector: 'pvmo-edoc',
  imports: [PageComponent, LoaderComponent],
  templateUrl: './edoc.component.html',
  styleUrl: './edoc.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EdocComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translationService = inject(TranslationService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly logService = inject(LogService);
  private readonly userService = inject(UserService);
  private readonly applicationStore = inject(ApplicationStore);
  private readonly appConfig = inject(AppConfig);

  private readonly LANDING = 'mobi-edoc';
  private readonly PAGE_NAME = 'page-edoc';

  isUserConnected = this.userService.isUserConnected;
  isLoading = signal(true);

  constructor() {
    effect(() => {
      const selected = this.translationService.selectedFile();
      formLanguageReloader(this.LANDING, this.PAGE_NAME, selected);
      this.cdr.markForCheck();
    });

    effect(() => {
      const userData = this.applicationStore.instant('userData')();
      let userSub: string | NoValue = undefined;
      if (this.appConfig.devOrLocal) {
        userSub = userData?.login;
      }
      untracked(() => {
        this.createDetailComponent(userSub);
      });
    });
  }

  private createDetailComponent(userSub: string | NoValue): void {
    const detailComponent = document.createElement(this.LANDING);
    const token = this.activatedRoute.snapshot.queryParamMap.get('token');
    const externalId = this.activatedRoute.parent?.snapshot.paramMap.get('id');
    const signatureType = this.applicationStore.instant('signatureData')()?.signatureType;

    detailComponent.setAttribute('nonce', 'NGINX_CSP_NONCE');
    detailComponent.setAttribute('session-uuid', this.logService.sessionUuid());
    if (userSub) {
      detailComponent.setAttribute('user-sub', userSub);
    }

    if (externalId && token) {
      detailComponent.setAttribute('token', token);
      detailComponent.setAttribute('external-id', externalId);
    }
    detailComponent.setAttribute('language', this.translationService.selectedFile());

    if (signatureType) {
      detailComponent.setAttribute('signature-type', signatureType);
    }

    const page = document.getElementById(this.PAGE_NAME);
    if (page) {
      this.isLoading.set(false);
      page.append(detailComponent);
      this.cdr.markForCheck();
    }
  }
}
